// Module
var code = "<booth-setting-layout sub-location=\"'booth'\"> <remote-paged-grid-layout base-path=\"'/booth/booth'\" new-entity-label-code=\"'booth.new'\" find-page=\"findPage\" export-to-csv=\"exportToCsv\" columns=\"columns\"> </remote-paged-grid-layout> </booth-setting-layout> ";
// Exports
export default code;